// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_ay_","cls2":"buttonStyles-cls2_0_E buttonStyles-cls1_ay_"};